import { motion } from "framer-motion";
import PageHero from "@/components/PageHero";
import { LEADERSHIP } from "@/lib/data";
import { Linkedin, Mail } from "lucide-react";

export default function Leadership() {
  return (
    <div data-testid="leadership-page">
      <PageHero
        eyebrow="Our Leadership"
        title={<>Leaders who put <em className="not-italic font-serif italic text-shramik-green">people first.</em></>}
        subtitle="A cross-functional team combining decades of on-ground experience with a modern operating playbook."
      />

      <section className="py-20 md:py-28" data-testid="leadership-grid">
        <div className="container-page">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {LEADERSHIP.map((p, i) => (
              <motion.div
                key={p.name}
                initial={{opacity:0, y:24}} whileInView={{opacity:1, y:0}} viewport={{once:true}}
                transition={{duration:0.5, delay: i * 0.06}}
                className={`group rounded-3xl overflow-hidden border border-slate-100 bg-white card-hover ${i % 2 === 1 ? "lg:mt-14" : ""}`}
                data-testid={`leader-${i}`}
              >
                <div className="aspect-[4/5] overflow-hidden relative bg-slate-100">
                  <img src={p.photo} alt={p.name} loading="lazy" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105"/>
                  <div className="absolute inset-0 bg-gradient-to-t from-shramik-ink/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"/>
                  <div className="absolute bottom-4 left-4 right-4 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                    <span className="w-8 h-8 rounded-full bg-white flex items-center justify-center"><Linkedin className="w-4 h-4 text-shramik-ink"/></span>
                    <span className="w-8 h-8 rounded-full bg-white flex items-center justify-center"><Mail className="w-4 h-4 text-shramik-ink"/></span>
                  </div>
                </div>
                <div className="p-6">
                  <div className="font-display font-medium text-lg md:text-xl leading-tight">{p.name}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
